export function stampNew(ctx) {
    const now = ctx.clock.now();
    return {
        createdAt: now,
        updatedAt: now,
        deletedAt: null,
        hlc: ctx.ids.nextHlc(),
        deviceId: ctx.ids.deviceId(),
    };
}
export function stampUpdate(ctx, row) {
    return { ...row, updatedAt: ctx.clock.now(), hlc: ctx.ids.nextHlc(), deviceId: ctx.ids.deviceId() };
}
//# sourceMappingURL=context.js.map